import { ResponsiveContainer, ComposedChart, Area, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Cell } from "recharts";
import { InfoHint } from "./InfoHint";
import { PiggyBank } from "@phosphor-icons/react";

export default function SleepBankCard({ bank }) {
  if (!bank) return null;
  const debt = bank.current_debt_h;
  const nights = 3;
  const perNight = Math.round((bank.baseline_h + debt / nights) * 10) / 10;
  const data = bank.days.map((d) => ({ ...d, label: d.date.slice(8, 10) + "." + d.date.slice(5, 7) }));
  const debtColor = debt >= 3 ? "#ff3b30" : debt >= 1 ? "#ffea00" : "#00e676";
  return (
    <div className="glass-card p-5" data-testid="sleep-bank-card">
      <div className="flex items-center gap-2 mb-1 flex-wrap">
        <PiggyBank size={18} weight="fill" style={{ color: debtColor }} />
        <h3 className="text-sm font-semibold">Банк сна · накопленный долг за 14 дней<InfoHint text="Банк сна — сумма недосыпа или пересыпа относительно вашей потребности за последние 14 дней. Большой долг снижает восстановление, концентрацию и HRV." /></h3>
        <span className="ml-auto text-sm num font-bold" style={{ color: debtColor }} data-testid="sleep-bank-debt">
          {debt > 0 ? `−${debt} ч` : "0 ч"}
        </span>
      </div>
      <p className="text-xs text-muted-foreground mb-4" data-testid="sleep-bank-advice">
        {debt > 0
          ? <>Чтобы выйти в ноль за {nights} ночи — спите по <span className="text-foreground font-semibold num">{perNight} ч</span> (ваша база {bank.baseline_h} ч + погашение долга).</>
          : <>Долга нет — вы спите свою норму ({bank.baseline_h} ч). Так держать!</>}
      </p>
      <ResponsiveContainer width="100%" height={200}>
        <ComposedChart data={data}>
          <CartesianGrid strokeDasharray="3 3" stroke="hsl(220 10% 16%)" vertical={false} />
          <XAxis dataKey="label" stroke="hsl(220 10% 40%)" fontSize={10} tickLine={false} axisLine={false} />
          <YAxis yAxisId="h" stroke="hsl(220 10% 40%)" fontSize={11} tickLine={false} axisLine={false} width={30} />
          <Tooltip contentStyle={{ background: "hsl(220 10% 12%)", border: "1px solid hsl(220 10% 22%)", borderRadius: 8, fontSize: 12 }}
            formatter={(v, n) => [n === "debt" ? `${v} ч` : `${v} ч`, n === "debt" ? "Долг сна" : n === "sleep_h" ? "Сон" : "±к норме"]} />
          <Bar yAxisId="h" dataKey="delta" name="±к норме" radius={[2, 2, 2, 2]}>
            {data.map((d, i) => <Cell key={i} fill={d.delta >= 0 ? "#00e676" : "#ff3b30"} fillOpacity={0.6} />)}
          </Bar>
          <Area yAxisId="h" type="monotone" dataKey="debt" name="debt" stroke="#ff9100" fill="#ff9100" fillOpacity={0.15} strokeWidth={2} />
        </ComposedChart>
      </ResponsiveContainer>
      <p className="text-[10px] text-muted-foreground mt-2">Оранжевая линия — накопленный долг (не уходит в плюс: «отоспаться впрок» нельзя, но можно погасить долг).</p>
    </div>
  );
}
